import * as CalculationUtils from 'util/CalculationUtils';

export function nicelyRoundUp(value) {
  return CalculationUtils.nicelyRoundUp(value) || '';
}

export function roundToWholeNumber(value) {
  return CalculationUtils.roundWholeNumber(value) || '';
}
